<template>
  <div class="text-center">
    <!-- <v-btn dark color="orange darken-2" @click="snackbar = true"> Open Snackbar </v-btn> -->
    <v-snackbar
      v-model="snackbar"
      :top="options.y === 'top'"
      :left="options.x === 'left'"
      :bottom="options.y === 'bottom'"
      :right="options.x === 'right'"
      :timeout="options.timeout"
      :color="options.color"
    >
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" @click="snackbar = false" icon outlined>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
/**
 * Vuetify notify Dialog component
 *
 * Insert component where you want to use it:
 * <notify ref="notify"></notify>
 *
 * Call it: example, only have 4 arg for options
 * this.$refs.notify.show(text, options);
 * this.$refs.notify.show('text',{ x:'left', y:'top',timeout:25, color: 'red' })

 * Alternatively you can place it in main App component and access it globally via this.$root.$notify
 * <template>
 *   <v-app>
 *     ...
 *     <notify ref="notify"></notify>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$notify = this.$refs.notify;
 * }
 * and call with
 *  this.$root.$notify.show(text,options);
 */
export default {
  data: () => ({
    snackbar: false,
    text: 'My timeout  default is 4000.',
    promise: null,
    options: {
      x: 'right',
      y: 'bottom',
      timeout: 5000,
      color: 'primary',
    },
  }),
  methods: {
    show(text, options) {
      return new Promise((resolve, reject) => {
        if (this.snackbar) this.snackbar = false;
        this.$nextTick(() => {
          this.promise = Object.assign({}, { resolve, reject });
          this.text = text ? text : this.text;
          this.options = Object.assign(this.options, options);
          this.snackbar = true;
        });
      });
    },
    close() {
      this.promise.resolve(true);
      this.snackbar = false;
    },
  },
};
// =============documentation for update
// https://github.com/Aymkdn/v-snackbars/blob/master/v-snackbars.vue
// https://codesandbox.io/s/v-snackbars-demo-8xrbr?file=/src/App.vue:800-813
</script>